export const TERMS_URL = `${process.env.LANDING_PAGE_URL}/terms`;

export const PRIVACY_POLICY_URL = `${process.env.LANDING_PAGE_URL}/privacy-policy`;
